var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonasIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.3825 0.39978C8.20803 0.39978 8.03912 0.423752 7.87842 0.467701C8.30814 0.960901 8.56894 1.60526 8.56894 2.31088C8.56894 3.01649 8.31324 3.64776 7.89129 4.13918C8.048 4.18091 8.21247 4.20355 8.3825 4.20355C9.43282 4.20355 10.2845 3.3521 10.2845 2.30178C10.2845 1.25145 9.43304 0.400002 8.3825 0.400002V0.39978Z",
    fill: "#223D51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.00795 0.39978C3.18241 0.39978 3.35133 0.423752 3.51203 0.467701C3.08231 0.960901 2.8215 1.60526 2.8215 2.31088C2.8215 3.01649 3.0772 3.64776 3.49915 4.13918C3.34245 4.18091 3.17798 4.20355 3.00795 4.20355C1.95763 4.20355 1.10596 3.3521 1.10596 2.30178C1.10596 1.25145 1.9574 0.400002 3.00795 0.400002V0.39978Z",
    fill: "#223D51"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36729 7.13399C1.36729 6.25813 2.15459 5.70611 3.09682 5.38648C3.31457 5.31257 3.53497 5.24642 3.75827 5.1876C2.84733 5.12789 1.98101 5.25375 1.17152 5.52831C0.533376 5.74473 0 6.11873 0 6.71204C0 7.30534 0.515175 7.70954 1.15509 7.89377C1.33044 7.94415 1.50535 7.98721 1.67959 8.02384C1.48315 7.76991 1.36751 7.47204 1.36751 7.13421L1.36729 7.13399Z",
    fill: "#223D51"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2187 5.52843C9.30623 5.23655 8.42726 5.13334 7.5918 5.18639C7.82419 5.24499 8.05792 5.31135 8.29342 5.3866C9.2412 5.6898 10.023 6.25824 10.023 7.13411C10.023 7.46927 9.90953 7.76604 9.7162 8.01929C9.89843 7.98156 10.0722 7.93939 10.2351 7.89366C10.8768 7.71387 11.3902 7.29991 11.3902 6.71194C11.3902 6.12396 10.8609 5.73352 10.2187 5.52821V5.52843Z",
    fill: "#223D51"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.69482 4.6035C6.96604 4.6035 7.99657 3.57297 7.99657 2.30175C7.99657 1.03053 6.96604 0 5.69482 0C4.4236 0 3.39307 1.03053 3.39307 2.30175C3.39307 3.57297 4.4236 4.6035 5.69482 4.6035Z",
    fill: "#223D51"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04225 8.51623C6.83833 8.85384 5.10769 9.02297 3.3473 8.51623C2.66166 8.31891 2.10986 7.88031 2.10986 7.25038C2.10986 6.6149 2.68119 6.21426 3.36462 5.98253C4.77563 5.50376 6.34757 5.44605 8.0245 5.98253C8.71214 6.20249 9.27925 6.6149 9.27925 7.25038C9.27925 7.88009 8.72923 8.32357 8.04181 8.51623H8.04225Z",
    fill: "#223D51"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonasIcon);
export default __webpack_public_path__ + "static/media/personasIcon.e342b65be9a2e7093f9ac52d05273d1f.svg";
export { ForwardRef as ReactComponent };